import { EnrichedBacklogMetricsByWorkstream } from '@/pages/OperationsInsights/types/BacklogMetricsResponseEnriched';
import { AggregationPeriod } from '@/pages/OperationsInsights/types/Interval';
import { roundToOneDecimal } from '@/pages/OperationsInsights/utils/roundNumber';
import BacklogGrowthPercentageCellRenderer from '@/pages/agGridUtils/BacklogGrowthPercentageCellRenderer.vue';
import { calculateDurationInHour } from '@/utils';

export const tfGdBLTrendByWorkstreamGridData = (metrics: EnrichedBacklogMetricsByWorkstream[], aggregationPeriod: AggregationPeriod | undefined) => {
    const gridMap = new Map<number, object>();
    for (const wsMetrics of metrics) {
        const createdTotal = wsMetrics.createdCount ?? 0;
        const closedTotal = wsMetrics.closedCount ?? 0;
        // PF-1558 - Change is calculated as Created - Completed
        const changesByCreatedAndClosed = createdTotal - closedTotal;
        const changesByCreatedAndClosedTxt = (changesByCreatedAndClosed > 0 ? '+' : '' ) + changesByCreatedAndClosed;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const row: any = {
            name: wsMetrics.name,
            createdTotal,
            closedTotal,
            changesByCreatedAndClosed: changesByCreatedAndClosedTxt,
            // PF-1558 - Growth Trend is calculated as (Change  / Completed) * 100
            growthTrend: closedTotal ? roundToOneDecimal((changesByCreatedAndClosed / closedTotal) * 100) : 0,
            completionRate: calculateCompletionRate(closedTotal, aggregationPeriod)
        };

        gridMap.set(wsMetrics.workstreamDefinitionId, row);
    }
    return Array.from(gridMap.values());
};

const calculateCompletionRate = (closedTotal: number, aggregationPeriod: AggregationPeriod | undefined): string => {
    // If the aggregation period isn't returned with the metrics then rate metrics based on duration can't be calculated. This shouldn't happen in a normal situation
    const duration =
        aggregationPeriod?.fromDate && aggregationPeriod?.toDate
            ? calculateDurationInHour(aggregationPeriod?.fromDate, aggregationPeriod?.toDate)
            : undefined;

    // Default to a blank value if the aggregation period isn't provided. Any other number wouldn't make sense
    return duration !== undefined ? `${roundToOneDecimal(closedTotal / duration )}/hr` : '';
};

export const getBLTrendByWorkstreamColumnDefs = () => {
    return [
        {
            field: 'name', headerName: 'Workstream', flex: 2, filter: true
        },
        {
            field: 'createdTotal', headerName: 'Created', flex: 1, filter: true
        },
        {
            field: 'closedTotal', headerName: 'Completed', flex: 1, filter: true
        },
        {
            field: 'changesByCreatedAndClosed', headerName: 'Change', flex: 1, filter: true
        },
        {
            field: 'growthTrend', headerName: 'Growth Trend', flex: 1, filter: true, cellRenderer: BacklogGrowthPercentageCellRenderer
        },
        {
            field: 'completionRate', headerName: 'Completion Rate', flex: 1, filter: true
        }
    ];
};